<div class="container-fluid d-flex flex-column justify-content-center align-items-center">
  <img src="assets/chapps-logo.png"/>
  <mdb-card id="login-card" class="m-3">
      <mdb-card-body class="pb-2">
        <h5 appTitle id="app-name" class="text-center mb-4" [translate]="Localization.SetPassword"></h5>
        <form #form="ngForm">
          <input type="password" id="passwordInput" name="passwordInput" class="form-control mb-2" (focus)="onInputFocus()"
                 [(ngModel)]="password"
                 [placeholder]="Localization.Password | translate">
          <input type="password" id="confirmPasswordInput" name="confirmPasswordInput" class="form-control mb-2" (focus)="onInputFocus()"
                 [(ngModel)]="confirmPassword"
                 [placeholder]="Localization.ConfirmPassword | translate">
        </form>
        <div *ngIf="!doesPasswordHaveTargetedLenght() && form.touched" class="alert alert-warning mb-0" role="alert"
             [translate]="Localization.BadPasswordLength" [translateParams]="{value: applicationConfig.MIN_PASSWORD_LENGTH}"></div>
        <div *ngIf="!areBothPasswordEqual() && doesPasswordHaveTargetedLenght()" class="alert alert-warning mb-0" role="alert"
             [translate]="Localization.PasswordsDoNotMatch"></div>
        <div *ngIf="isPasswordCreationDone" class="alert alert-success mb-0" role="alert"
             [translate]="Localization.PasswordSetSuccess"></div>
        <div *ngIf="isPasswordCreationError" class="alert alert-danger mb-0" role="alert"
             [translate]="Localization.PasswordSetError"></div>
      </mdb-card-body>
      <mdb-card-footer class="text-center">
        <button *ngIf="!isProccessing" type="button" class="mb-2"
                mdbBtn
                appBg="primary"
                brightness="normal"
                appTextColor="primary"
                [block]="true"
                (click)="onSubmit()"
                mdbWavesEffect
                [disabled]="!areBothPasswordEqual() || !doesPasswordHaveTargetedLenght()"
                [translate]="Localization.Submit">
        </button>
        <button *ngIf="!isProccessing" type="button"
                mdbBtn
                color="light"
                [block]="true"
                (click)="goToLoginPage()"
                mdbWavesEffect
                [translate]="Localization.GoToLoginPage">
        </button>
        <mdb-spinner *ngIf="isProccessing"></mdb-spinner>
      </mdb-card-footer>
  </mdb-card>
</div>

